import { z } from "zod";

export default {
  params: z.object({
    memberInvitationId: z.string(),
  }),
  response: z.void(),
};
